import Image from './Image'
import researchInstitute from '../assets/researchInstitute.png';
import newModel from '../assets/newModel.png';
import algorithm from '../assets/algorithm.png';
import classes from "./Scientific.module.css";
import Layout from "./Layout";
import CommonTitle from "./CommonTitle";

export default function Scientific({id}) {

    return (

        <Layout id={id}>
            <CommonTitle title="科研"/>
            <div className={classes["research-content-area"]}>
                <div className={classes["research-content-area-col"]}>
                    <div className={classes["app-content-top"]}>
                        <div className={classes["app-content-top-img"]}>
                            <Image src={researchInstitute} height={166} alt=""/>
                        </div>
                        <span className={classes["content-top-title"]}>北京华夏智星安全科学技术研究院</span>
                        <div className={classes["content-top-text"]}>
                            <span>安全技术，管理，趋势研究</span>
                            <span>安全专业联盟</span>
                            <span>课题，标准研究</span>
                        </div>
                    </div>
                    <span className={classes["app-content-under"]}></span>
                </div>
                <div className={classes["research-content-area-col"]}>
                    <div className={classes["app-content-top"]}>
                        <div className={classes["app-content-top-img"]}>
                            <Image src={newModel} height={166} alt=""/>
                        </div>
                        <span className={classes["content-top-title"]}>风险智能评级算法研究</span>
                        <div className={classes["content-top-text"]}>
                            <span>建立神经网络算法</span>
                            <span>智能分级管控风险</span>
                            <span>大数据分析实现风险自动判断，预警</span>
                        </div>
                    </div>
                    <span className={classes["app-content-under"]}></span>
                </div>
                <div className={classes["research-content-area-col"]}>
                    <div className={classes["app-content-top"]}>
                        <div className={classes["app-content-top-img"]}>
                            <Image src={algorithm} height={166} alt=""/>
                        </div>
                        <span className={classes["content-top-title"]}>安责险创新模式</span>
                        <div className={classes["content-top-text"]}>
                            <span>助力安责险</span>
                            <span>为企业提供专业风控服务</span>
                            <span>第三方专业服务体系</span>
                        </div>
                    </div>
                    <span className={classes["app-content-under"]}></span>
                </div>
            </div>
        </Layout>
    )
}
